var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('LoadingSpinner',{attrs:{"loading":_vm.isLoading,"text":_vm.$lang.sending_data}}),(!_vm.isLoading)?_c('b-col',[_c('ResearchManagerForm',{attrs:{"title":_vm.$lang.researchLang.relationResearchManager,"parentPermissions":_vm.parentPermissions},on:{"submit":_vm.save,"closeModal":_vm.closeModal}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }